import { apiService } from './api';
import { Class } from '../types';

export interface ClassFormData {
  name: string;
  description?: string;
  centerId?: string;
  isActive?: boolean;
  isTerminal?: boolean;
}

export const classService = {
  // Get all classes for a center
  getClasses: async (params?: {
    centerId?: string;
    isActive?: boolean;
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    const response = await apiService.get<{ classes: Class[], pagination: any }>('/administration/classes', params);
    return {
      classes: response.data?.classes || [],
      pagination: response.data?.pagination || { totalItems: 0, totalPages: 1, currentPage: 1 }
    };
  },

  // Get single class by ID
  getClass: async (id: string) => {
    const response = await apiService.get<Class>(`/administration/classes/${id}`);
    return response.data;
  },

  // Create new class
  createClass: async (data: ClassFormData) => {
    const response = await apiService.post<Class>('/administration/classes', data);
    return response.data;
  },

  // Update class
  updateClass: async (id: string, data: Partial<ClassFormData>) => {
    const response = await apiService.put<Class>(`/administration/classes/${id}`, data);
    return response.data;
  },

  // Delete class
  deleteClass: async (id: string) => {
    const response = await apiService.delete(`/administration/classes/${id}`);
    return response.data;
  },

  // Reorder — full list of class _ids in the new desired order.
  // Backend re-assigns displayOrder values in 10-step gaps.
  reorderClasses: async (orderedClassIds: string[]) => {
    const response = await apiService.post<Class[]>('/administration/classes/reorder', { orderedClassIds });
    return response.data ?? [];
  }
};
